import {
  AssetType,
  FireTVCampaignAutomationClient,
  TransformationVariant,
  Placement,
} from '@amzn/fire-tv-campaign-automation-service';
import { ASSET_CONFIG } from 'src/configs/assetConfig';
import { AssetDetails, AssetState } from 'src/types';

import { AssetInputHandler } from '../AssetInputHandler';

/**
 * Creates an asset input handler based on the asset type
 * @param assetType - Type of asset to create handler for
 * @param setState - State setter function for the asset
 * @param placement - Placement for validation props
 * @returns Appropriate handler for the asset type
 */
export const createAssetHandler = (
  assetType: AssetType,
  setState: (state: Partial<AssetState>) => void,
  setAssetDetails: (assetDetails: Partial<AssetDetails>) => void,
  getTransformationVariant: () => TransformationVariant,
  controlPlaneClient: FireTVCampaignAutomationClient,
  placement: Placement,
): AssetInputHandler => {
  if (assetType in ASSET_CONFIG) {
    const { acceptedFileTypes, allowedContentTypes, ...handlerConfig } = ASSET_CONFIG[assetType];
    const resolvedContentTypes = allowedContentTypes[placement] ?? [];
    return new AssetInputHandler({
      ...handlerConfig,
      allowedContentTypes: resolvedContentTypes,
      setState,
      setAssetDetails,
      controlPlaneClient,
      assetType,
      getTransformationVariant,
      placement,
    });
  } else {
    throw new Error(`Unsupported asset type: ${assetType}`);
  }
};
